import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import MasonryGridSection from "../../../V2/Layouts/MasonryGridSection"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokMasonryGridSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.MasonrySection>) => {
  const blokHeading = blok.heading?.[0] || ({} as Storyblok.LayoutHeading)

  return (
    <MasonryGridSection
      id={blok.id}
      heading={{
        ...blokHeading,
        size: blokHeading?.size || "large",
        callout: blokHeading?.callout?.[0],
      }}
      primaryBackgroundColor={blok.primaryBackgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      ctaType={blok.ctaType}
      ctaText={blok.ctaText}
      ctaColor={blok.ctaColor}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      {blok.content.map((content) => (
        <StoryblokComponent key={content._uid} blok={content} />
      ))}
    </MasonryGridSection>
  )
}

export default StoryblokMasonryGridSection
